// @refresh reset
import { NextSeo } from 'next-seo'
import { Container, Text } from 'components/ui'
import Layout, { Breadcrumb, BreadcrumbProps } from 'components/layout'
import { POSTS } from 'modules/posts/constants'
import { emptyImagePlaceholder } from 'constants/image'
import { PostSection } from 'modules/posts/components'
import s from './blog-page.module.css'
import { Post } from 'framework/posts'
import { useEffect, useState } from 'react'
import PostsService from 'modules/posts/services/posts-service'
import { slugify } from 'helpers/slugfy'

interface ProductPageProps {
  slug: string,
  posts: Post[],
}

interface Params {
  params: {
    slug: string
  }
}

export const getServerSideProps = async ({ params: { slug } }: Params) => {
  return {
    props: {
      slug,
    },
  }
}

const formatDate = (dateString: string) => {
  const months = [
    'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
    'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
  ];

  const date = new Date(dateString);
  const day = date.getUTCDate();
  const month = months[date.getUTCMonth()];
  const year = date.getUTCFullYear();

  return `${day} de ${month} de ${year}`;
};

const getPosts = async () => {
  const postService = new PostsService();
  const postsResponse = await postService.getAllPosts();

    let trasformedPosts: Post[] = [];

    if(postsResponse.data && postsResponse.data.data && Array.isArray(postsResponse.data.data)) {
      trasformedPosts = postsResponse.data.data.map((post: any) => {
        return {
          id: post.id,
          categories: [{ name: post.categoria, slug: slugify(post.categoria) }],
          content: post.conteudo,
          createdAt: formatDate(post.created_at),
          description: post.descricao,
          image: {
            url: post.imagem
          },
          slug: slugify(post.titulo),
          title: post.titulo,
        } as Post
      })
    }

    return trasformedPosts;
};

function ProductPage({ slug }: ProductPageProps) {

  const [postsFromAPI, setPostsFromAPI] = useState<Post[]>([]);

  useEffect(() => {
    const getPostsFromAPI = async () => {
      const posts = await getPosts();
      setPostsFromAPI(posts)
    }

    getPostsFromAPI();
  }, []);

  console.log("posts function: ", postsFromAPI)

  const blog = [...postsFromAPI, ...POSTS].find((post) => post.slug === slug)
  const crumbs: BreadcrumbProps['crumbs'] = [{ url: '/blog', label: 'Blog' }, { label: blog?.title || '' }]

  console.log(blog)

  return (
    <Layout>
      <NextSeo
        title={blog?.title}
        description={blog?.description}
        openGraph={{
          type: 'website',
          title: blog?.title,
          description: blog?.description,
          images: [
            {
              url: blog?.image?.url!,
              width: 800,
              height: 600,
              alt: blog?.title,
            },
          ],
        }}
      />
      <Breadcrumb crumbs={crumbs} />
      <Container>
        <div className={s.view}>
          <img
            src={blog?.image?.url.charAt(blog?.image?.url.length - 1) === "/" || !blog?.image?.url ? "/assets/images/default.png" : blog?.image?.url}
            alt={blog?.title}
            onError={(e) => (e.currentTarget.src = "/assets/images/default.png")}
          />
          <article className={s.content}>
            <Text className={s.title} variant="headingOne">
              {blog?.title}
            </Text>
            {typeof blog?.content === "string" ? (
              <div dangerouslySetInnerHTML={{ __html: blog.content }} />
            ) : (
              blog?.content
            )}
          </article>
          <div className={s.section}>
            <div className={s.other}>Também vale a pena você ler:</div>
            <PostSection ignore={slug} limit={3} />
          </div>
        </div>
      </Container>
    </Layout>
  )
}

export default ProductPage
